import React from "react";
import Navbar from "../navigation/Navbar";
import OrderStarter from "./OrderStarter";
import Hero from "./Hero";
import OurOffer from "./OurOffer";
import Compare from "./Compare";
import Banner from "./Banner";
import DividerComponent from "../ui/DividerComponent";
import CTAs from "./CTAs";
import Footer from "../navigation/Footer";
import FloatingWidget from "../navigation/FloatingWidget";
import WaterService from "./WaterService";
import Marquee from "../ui/Marquee";

const Index = () => {
  const beneficios = [
    "Agua purificada",
    "Pide en línea",
    "Recibe a domicilio",
    "Sin cargar botellones",
    "Sin acumular plásticos",
    "Purificación en 6 pasos",
    "Filtros de lecho profundo",
    "Osmosis inversa",
    "Carbon Activado",
    "Luz UV",
  ];
  return (
    <div className="max-w-screen overflow-hidden">
      <Navbar />
      <div className="flex flex-col wf-ull justify-center items-center gap-24">
        <div className="flex flex-col w-full relative z-[9997]">
          <Hero />
          <Marquee
            items={beneficios}
            direction="left"
            speed={64}
            separator="⠀⠀⠀⠀"
            pauseOnHover={false}
            className="bg-blue-900 text-white py-4"
          />
        </div>
        <WaterService />
        {/* <OurOffer /> */}
        <DividerComponent
          color="fbfbfb"
          margin={0}
          size={8}
          direction="horizontal"
        />
        <Compare container={true} />
        <DividerComponent
          color="fbfbfb"
          margin={0}
          size={8}
          direction="horizontal"
        />
        <CTAs />
        {/* <WhatsappFloat /> */}
        <FloatingWidget />
        <Footer />
      </div>
    </div>
  );
};

export default Index;
